export default "__VITE_ASSET__Rf8q$BnO__"